module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/jszip/node_modules/core-js/library/modules/_html.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_html.js
// module chunks = common